<script setup>
import { EventManager } from "@events";
import { ref } from "vue";
const dialog = ref(false);

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
});

const eventEmitter = EventManager.getEventEmitter(props.rtcId);

eventEmitter.on("webrtc-ice-disconnect-popup-show", () => {
  dialog.value = true;
});

eventEmitter.on("webrtc-ice-disconnect-popup-hide", () => {
  dialog.value = false;
});
</script>

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent width="auto">
      <v-alert
        :title="$t('warning')"
        :text="$t('WEBRTC_DISCONNECT_WARNING')"
        type="info"
        icon="mdi-information"
      ></v-alert>
    </v-dialog>
  </v-row>
</template>
